import { useContext, useEffect, useRef } from 'react';
import { FloatingActionsContext } from './FloatingActionsContext';
import type { FloatingActionDefinition } from './FloatingActionsContext';

export function useFloatingAction(action: FloatingActionDefinition) {
    const store = useContext(FloatingActionsContext);
    const ownerRef = useRef<symbol | null>(null);
    if (ownerRef.current === null) {
        ownerRef.current = Symbol(action.id);
    }

    if (store === null) {
        throw new Error('useFloatingAction debe usarse dentro de FloatingActionsProvider.');
    }

    useEffect(() => {
        const owner = ownerRef.current;
        if (owner === null) {
            return;
        }

        store.setAction(action, owner);
    }, [action, store]);

    useEffect(() => {
        const owner = ownerRef.current;
        const actionId = action.id;

        return () => {
            if (owner !== null) {
                store.removeAction(actionId, owner);
            }
        };
    }, [action.id, store]);
}
